<script>
//
export let pageCopy;
export let pageTitle;
export let buttonText;
export let buttonLink;
let theTitle;

if (pageTitle !== null) {
    theTitle = pageTitle;

} else {
    theTitle = "";
}

</script>
<section>

	<div class="para">
    {#if theTitle !== ""}
    	<h2>{@html pageTitle}</h2>
    {/if }
    <div class="para-container">
       <p>{@html pageCopy}</p>
       <div class="fic--cta_large-text_cta fic--button fic--button_cta-large fic-button-para">
            <a href="{ buttonLink}" >{@html buttonText }</a>
       </div>
    </div>
    </div>
</section>